import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import NotesComponent from "../notes/NotesComponent"
import TabHeader from "../../tab/TabHeader"
import ServicesDetails from "./ServicesDetails"
import ServicesFilters from "./ServicesFilters"
import LoadingSpinner from "../../../common/LoadingSpinner"
import { servicesActions } from "../../../../store/services"
import Button from "../../../common/Button"
import AscReferralModal from "./AscReferralModal"
import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions"
import classes from "./ServicesTab.module.css"

const ServicesTab = ({ inWorkQ }) => {
    const dispatch = useDispatch()
    const activeCase = useSelector(state => state.case.activeCase)
    const [contentReady, setContentReady] = useState(false)
    const [showAscReferralModal, setShowAscReferralModal] = useState(false)
    const servicesEditDisabled = useUserTabEditPermissionDisabled('case_services')

    useEffect(() => {
        return () => {
            dispatch(servicesActions.setFilterResult(null))
        }
    }, [dispatch])

    // Keep one-frame defer so loader can paint, but avoid long idle delays.
    useEffect(() => {
        const services = activeCase?.services
        if (!services || services.length === 0) {
            setContentReady(true)
            return undefined
        }

        setContentReady(false)
        let cancelled = false
        const finish = () => {
            if (!cancelled) {
                setContentReady(true)
            }
        }

        const id = window.requestAnimationFrame(finish)
        return () => {
            cancelled = true
            cancelAnimationFrame(id)
        }
        /* Only re-defer when the case changes; services updates while staying on this tab should not flash the loader. */
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeCase?.case?.id])

    const hasServicesList = !!(activeCase?.services && activeCase.services.length > 0)
    const showServicesLoader = !contentReady && hasServicesList
    const openAscReferralModal = () => {
        setShowAscReferralModal(true)
    }
    const closeAscReferralModal = () => {
        setShowAscReferralModal(false)
    }

    return <>
        <TabHeader>
            <div className={`flex-container ${classes.header_actions}`}>
                <h2>Services</h2>
                <NotesComponent noteTypeId={10} inWorkQ={inWorkQ}/>
                <div className={classes.asc_referral_button}>
                    <Button click={openAscReferralModal} isDisabled={servicesEditDisabled || !activeCase?.case?.id}>
                        <i className="ti ti-square-plus"></i>
                        ASC REFERRAL
                    </Button>
                </div>
            </div>
            {contentReady && hasServicesList && (
                <ServicesFilters services={activeCase.services}/>
            )}
        </TabHeader>
        {showAscReferralModal && <AscReferralModal closeModal={closeAscReferralModal} />}
        {showServicesLoader && (
            <div style={{ minHeight: 160, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <LoadingSpinner />
            </div>
        )}
        {(contentReady || !hasServicesList) && <ServicesDetails servicesEditDisabled={servicesEditDisabled} />}
    </>
}

export default ServicesTab